import { Conversion, MeasurementUnitModel, MuConversion, syncMuConversions } from '@msdk/definitions'
import { selector } from 'recoil'

import { $refToken } from '../auth'
import { $apiClient } from '../core'

export const $measurementUnit = selector({
  key: 'MeasurementUnit',
  get: async ({ get }) => {
    const client = get($apiClient)
    const token = get($refToken)
    if (token) {
      try {
        const res = (await client.read<MuConversion[]>('CMPS/api/MU/LoadMUConversion')) as MuConversion[]
        const conversions: Record<string, Conversion> = {}
        res.forEach((c) => {
          const conversion: Conversion = {
            um: c.measurementUnitDestination,
            factor: c.conversionFactor,
            offset: c.conversionOffset,
          }
          const keys = getConversionKeys(c)
          keys.forEach((k) => {
            conversions[k] = conversion
          })
        })
        syncMuConversions(conversions)
        return conversions
      } catch (err) {
        console.warn('[measurementUnit] error while getting measurement units, proceding without them!', err)
        return []
      }
    }
  },
})

export const $measurementUnitsList = selector({
  key: 'MeasurementUnitsList',
  get: async ({ get }) => {
    const client = get($apiClient)
    const token = get($refToken)
    if (token) {
      const res = (await client.read<MeasurementUnitModel[]>(
        'CMPS/api/metadata/measurementunit',
      )) as MeasurementUnitModel[]
      return res
    }
  },
})

function getConversionKeys(c: MuConversion) {
  const res = []
  if (c.measurementUnitEntityName && c.measurementUnitFieldName) {
    res.push(`${c.measurementUnitSource}.${c.measurementUnitEntityName}.${c.measurementUnitFieldName}`)
    res.push(`${c.measurementUnitDestination}.${c.measurementUnitEntityName}.${c.measurementUnitFieldName}`)
  } else if (c.measurementUnitEntityName && !c.measurementUnitFieldName) {
    res.push(`${c.measurementUnitSource}.${c.measurementUnitEntityName}`)
    res.push(`${c.measurementUnitDestination}.${c.measurementUnitEntityName}`)
  } else {
    res.push(`${c.measurementUnitSource}`)
    res.push(`${c.measurementUnitDestination}`)
  }
  return res
}
